import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  FiArrowRight, 
  FiHeart, 
  FiSun, 
  FiWind, 
  FiBookOpen, 
  FiChevronLeft, 
  FiChevronRight,
  FiCompass,
  FiInstagram,
  FiFacebook,
  FiTwitter,
  FiSmartphone,
  FiShield,
  FiAward,
  FiMusic,
  FiLayers,
  FiGift,
  FiCopy,
  FiShare2,
  FiClock,
  FiMail,
  FiPhone,
  FiMapPin,
  FiMenu,
  FiX
} from "react-icons/fi";
import toast from "react-hot-toast";
import loginicon from "../Assets/logo.jpg";
import hero1 from "../Assets/landing_hero_new/hero1.jpg";
import hero2 from "../Assets/landing_hero_new/hero2.jpg";
import hero3 from "../Assets/landing_hero_new/hero3.jpg";
import hero4 from "../Assets/landing_hero_new/hero4.jpg";
import hero5 from "../Assets/landing_hero_new/hero5.jpg";
import hero6 from "../Assets/landing_hero_new/hero6.jpg";
import hero7 from "../Assets/landing_hero_new/hero7.jpg";
import hero8 from "../Assets/landing_hero_new/hero8.jpg";
import hero10 from "../Assets/landing_hero_new/hero10.jpg";
import hero11 from "../Assets/landing_hero_new/hero11.jpg";
import hero12 from "../Assets/landing_hero_new/hero12.jpg";
import hero13 from "../Assets/landing_hero_new/hero13.jpg";
import hero14 from "../Assets/landing_hero_new/hero14.jpg";
import hero15 from "../Assets/landing_hero_new/hero15.jpg";
import hero16 from "../Assets/landing_hero_new/hero16.jpg";
import hero17 from "../Assets/landing_hero_new/hero17.jpg";
import hero18 from "../Assets/landing_hero_new/hero18.jpg";
import hero19 from "../Assets/landing_hero_new/hero19.jpg";
import hero21 from "../Assets/landing_hero_new/hero21.jpg";

/* ─── Font injection ─────────────────────────────────────── */
const fontLink = document.createElement("link");
fontLink.href =
  "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,500;0,600;1,300;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap";
fontLink.rel = "stylesheet";
if (!document.head.querySelector('[href*="Cormorant"]')) document.head.appendChild(fontLink);

/* ─── Scroll reveal hook ─────────────────────────────────── */
const useReveal = () => {
  const [visible, setVisible] = useState(false);
  const ref = React.useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.05 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
};

/* ─── Reduced-motion preference ──────────────────────────── */
const usePrefersReducedMotion = () => {
  const query = "(prefers-reduced-motion: reduce)";
  const [reduced, setReduced] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(query).matches
  );
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener ? mq.addEventListener("change", onChange) : mq.addListener(onChange);
    return () => (mq.removeEventListener ? mq.removeEventListener("change", onChange) : mq.removeListener(onChange));
  }, []);
  return reduced;
};

/* ─── Horizontal swipe handlers for touch carousels ─────── */
const useSwipe = (onNext, onPrev) => {
  const start = React.useRef(null);
  return {
    onTouchStart: (e) => {
      const t = e.touches[0];
      start.current = { x: t.clientX, y: t.clientY };
    },
    onTouchEnd: (e) => {
      if (!start.current) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - start.current.x;
      const dy = t.clientY - start.current.y;
      start.current = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        if (dx < 0) onNext();
        else onPrev();
      }
    },
  };
};

/* ─── Reveal wrapper ─────────────────────────────────────── */
const Reveal = ({ children, delay = 0, direction = "up" }) => {
  const [ref, visible] = useReveal();
  const transforms = { up: "translateY(30px)", left: "translateX(-20px)", right: "translateX(20px)" };
  return (
    <div
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "none" : transforms[direction],
        transition: `opacity 0.8s ${delay}s cubic-bezier(0.16,1,0.3,1), transform 0.8s ${delay}s cubic-bezier(0.16,1,0.3,1)`,
      }}
    >
      {children}
    </div>
  );
};

/* ─── Marquee ────────────────────────────────────────────── */
const Marquee = () => {
  const items = ["Breathing", "Focus", "Clarity", "Relaxation", "Resilience", "Insight", "Presence", "Balance"];
  return (
    <div className="lp-marquee" aria-hidden="true" style={{
      overflow: "hidden",
      background: "#0f1a0d",
      padding: "14px 0",
      borderTop: "1px solid rgba(125,150,103,0.15)",
      borderBottom: "1px solid rgba(125,150,103,0.15)",
    }}>
      <div className="lp-marquee-track" style={{ display: "flex", animation: "marqueeScroll 22s linear infinite", whiteSpace: "nowrap", width: "max-content" }}>
        {[...items, ...items, ...items].map((item, i) => (
          <span key={i} style={{
            fontSize: 11, fontWeight: 600, letterSpacing: "0.22em",
            textTransform: "uppercase", color: "rgba(168,200,150,0.45)",
            padding: "0 28px",
            fontFamily: "'DM Sans', sans-serif",
          }}>
            {item}
            <span style={{ color: "rgba(125,150,103,0.3)", marginLeft: 28 }}>·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

/* ─── Main Landing Page Component ────────────────────────── */
const LandingPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("home");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const reducedMotion = usePrefersReducedMotion();

  // Mobile menu: lock body scroll, close on Escape and when resizing up to desktop
  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") setMobileMenuOpen(false); };
    const onResize = () => { if (window.innerWidth > 1024) setMobileMenuOpen(false); };
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, [mobileMenuOpen]);

  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Customer Reviews Carousel state for Our Community
  const communityReviews = [
    {
      id: 1,
      name: "Aarav Sharma",
      role: "Product Designer & Mindfulness Advocate",
      rating: 5,
      image: hero1,
      review: "MentalSwasthya completely changed my daily routine. The 4-7-8 breathing pacer and daily intention journal give me immense clarity before starting work!",
      date: "August 2026"
    },
    {
      id: 2,
      name: "Sarah Jenkins",
      role: "Wellness Coach",
      rating: 5,
      image: hero3,
      review: "The curated soundscapes and gift card options are wonderful. I gifted a 6-month Bloom card to my sister and she loves it!",
      date: "August 2026"
    },
    {
      id: 3,
      name: "Vikram Patel",
      role: "Software Engineer",
      rating: 5,
      image: hero5,
      review: "Tracking my streak with the Dragon Guard shield keeps me disciplined every morning. Best mental health investment.",
      date: "July 2026"
    },
    {
      id: 4,
      name: "Maya Lin",
      role: "Executive Lead",
      rating: 5,
      image: hero7,
      review: "The silent meditation bubble is so peaceful. It's my go-to tool whenever I feel overwhelmed during busy workdays.",
      date: "July 2026"
    }
  ];

  const curatedArticles = [
    {
      id: 0,
      category: "Meditation Research",
      readTime: "3 min read",
      title: "Can 7 Minutes of Meditation Make a Difference? What New Research Reveals",
      message: "Recent neuroscience research shows that even a short daily meditation practice can produce meaningful changes in focus, stress and mood.",
      date: "October 2026",
      tagColor: "#2b93b3",
      bgGradient: "linear-gradient(135deg, #17405a 0%, #0a1d2b 100%)",
      url: "https://share.google/yEJ3fGalcXM7RusU"
    },
    {
      id: 1,
      category: "Mindfulness & Breathing",
      readTime: "4 min read",
      title: "The Science of Mindful Breathing & Daily Peace",
      message: "Discover how regulating your breath for just 5 minutes daily calms the central nervous system, lowers anxiety, and creates immediate mental clarity.",
      date: "September 2026",
      tagColor: "#7d9667",
      bgGradient: "linear-gradient(135deg, #2e4a27 0%, #152612 100%)"
    },
    {
      id: 2,
      category: "Restorative Sleep",
      readTime: "5 min read",
      title: "Soundscapes & Sleep: Restoring Natural Rest",
      message: "Explore how acoustic frequencies and ambient soundscapes settle an overactive mind and prepare your body for deep, uninterrupted sleep.",
      date: "September 2026",
      tagColor: "#5478a3",
      bgGradient: "linear-gradient(135deg, #1e334d 0%, #0d1a29 100%)"
    },
    {
      id: 3,
      category: "Emotional Resilience",
      readTime: "3 min read",
      title: "Building Sustainable Intentions & Self-Compassion",
      message: "Small morning reflections cultivate long-term emotional stability. Aligning daily choices with core values leads to genuine peace of mind.",
      date: "August 2026",
      tagColor: "#b3823b",
      bgGradient: "linear-gradient(135deg, #4d3617 0%, #241808 100%)"
    }
  ];

  const [reviewIndex, setReviewIndex] = useState(0);
  const [articleIndex, setArticleIndex] = useState(0);

  useEffect(() => {
    if (reducedMotion) return undefined;
    const timer = setInterval(() => {
      setReviewIndex((prev) => (prev + 1) % communityReviews.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [communityReviews.length, reducedMotion]);

  const articleSwipe = useSwipe(
    () => setArticleIndex((prev) => (prev + 1) % curatedArticles.length),
    () => setArticleIndex((prev) => (prev === 0 ? curatedArticles.length - 1 : prev - 1))
  );
  const reviewSwipe = useSwipe(
    () => setReviewIndex((prev) => (prev + 1) % communityReviews.length),
    () => setReviewIndex((prev) => (prev === 0 ? communityReviews.length - 1 : prev - 1))
  );

  const handleContactSubmit = (e) => {
    e.preventDefault();
    if (!contactName.trim() || !contactEmail.trim() || !contactMessage.trim()) {
      toast.error("Please fill in all fields.");
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      toast.success("Thank you! Your message has been received.");
      setContactName("");
      setContactEmail("");
      setContactMessage("");
      setIsSubmitting(false);
    }, 1000);
  };

  const handleStart = () => {
    navigate("/login");
  };

  const copyReferralCode = () => {
    navigator.clipboard.writeText("SHARE_JOY24");
    toast.success("Gift code copied! Enter this during sign up for 3 months free.");
  };

  const navItems = [
    { label: "Home", id: "home" },
    { label: "Why Wellness", id: "why-wellness" },
    { label: "Tools", id: "tools" },
    { label: "Features", id: "features" },
    { label: "Offer", id: "offer" },
    { label: "Community", id: "community" },
    { label: "Contact", id: "contact" }
  ];

  const scrollToSection = (id) => {
    setActiveTab(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const slides = [
    hero1, hero2, hero3, hero4, hero5, hero6, hero7, hero8, hero10,
    hero11, hero12, hero13, hero14, hero15, hero16, hero17, hero18, hero19,
    hero21
  ];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (reducedMotion) return undefined;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length, reducedMotion]);

  const slideSwipe = useSwipe(
    () => setCurrentSlide((prev) => (prev + 1) % slides.length),
    () => setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
  );

  const tools = [
    {
      num: "01",
      title: "Daily Intentions Setting",
      icon: <FiBookOpen size={20} />,
      color: "#b5893d",
      accent: "rgba(181,137,61,0.08)",
      border: "rgba(181,137,61,0.18)",
      text: "Setting daily intentions aligns actions with values rather than external accomplishments. Daily journaling on behavioral goals trains the mind to show up with a deliberate presence. An intuitive daily canvas to write down behaviors and mindsets."
    },
    {
      num: "02",
      title: "Regulated Breathing",
      icon: <FiWind size={20} />,
      color: "#4a7c59",
      accent: "rgba(74,124,89,0.08)",
      border: "rgba(74,124,89,0.18)",
      text: "Science-backed diaphragmatic & regulated breathing triggers the vagus nerve, signaling the nervous system to transition from fight-or-flight to recovery. A responsive breathing bubble with visual and timing cues to guide inhalation, holding, and exhalation cycles."
    },
    {
      num: "03",
      title: "Sustained Meditation",
      icon: <FiSun size={20} />,
      color: "#7d6b3a",
      accent: "rgba(125,107,58,0.07)",
      border: "rgba(125,107,58,0.18)",
      text: "Mindful focus improves neuroplasticity in areas of the brain related to emotional regulation and attention, providing clarity for decision making under workplace pressure."
    },
    {
      num: "04",
      title: "Resilient Affirmations",
      icon: <FiHeart size={20} />,
      color: "#7d4a67",
      accent: "rgba(125,74,103,0.07)",
      border: "rgba(125,74,103,0.18)",
      text: "Deliberate cognitive restructuring using positive affirmations builds self-concept, replacing toxic self-evaluation loops with supportive neural pathways."
    }
  ];

  const features = [
    {
      title: "Intuitively designed interface",
      desc: "A simple, intuitive and easy to navigate design that empowers your wellness journey without the hastle. ",
      icon: <FiCompass size={22} />,
      badge: "User Experience"
    },
    {
      title: "Streak Reminders",
      desc: "Never miss a beat, receive timely notifications to keep your streak going and maintain your wellness consistency.",
      icon: <FiClock size={22} />,
      badge: "Consistency"
    },
    {
      title: "Certificate on milestone achievements",
      desc: "Earn certificates as you reach significant well-being milestones and complete progress goals.",
      icon: <FiAward size={22} />,
      badge: "Achievements"
    },
    {
      title: "Curated Soundscapes",
      desc: "Guided meditations, Affirmation and ambient tracks designed to filter out background corporate noise and facilitate deep concentration. Even you can upload your favorite one and listen!",
      icon: <FiMusic size={22} />,
      badge: "Sound & Focus"
    },
    {
      title: "Progress Analytics",
      desc: "A clean dashboard compiling session’s progress, total days/minutes, and active streaks to foster consistent habits.",
      icon: <FiLayers size={22} />,
      badge: "Insights"
    }
  ];

  return (
    <div style={{ background: "#f7f9f4", fontFamily: "'DM Sans', sans-serif", minHeight: "100vh" }}>
      
      {/* ══════════════════════════ HERO & HEADER ══════════════════════════ */}
      <header id="home" style={{
        background: "linear-gradient(168deg, #0a1208 0%, #162314 45%, #0d1b0b 100%)",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}>
        
        {/* Dot grid */}
        <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.05, pointerEvents: "none" }}>
          <defs>
            <pattern id="agrid" width="32" height="32" patternUnits="userSpaceOnUse">
              <circle cx="1" cy="1" r="1" fill="#a8c896" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#agrid)" />
        </svg>

        {/* Aurora blobs */}
        <div style={{
          position: "absolute", width: 800, height: 800, borderRadius: "50%",
          background: "radial-gradient(circle, rgba(100,140,80,0.18) 0%, transparent 65%)",
          top: -300, right: -250, pointerEvents: "none",
          animation: "blobDrift1 9s ease-in-out infinite",
        }} className="lp-blob" />
        <div style={{
          position: "absolute", width: 500, height: 500, borderRadius: "50%",
          background: "radial-gradient(circle, rgba(60,110,45,0.14) 0%, transparent 65%)",
          bottom: -100, left: -150, pointerEvents: "none",
          animation: "blobDrift2 12s ease-in-out infinite",
        }} className="lp-blob" />

        {/* Diagonal accent line at the bottom */}
        <svg style={{ position: "absolute", bottom: -1, left: 0, width: "100%", height: 100, pointerEvents: "none" }} preserveAspectRatio="none" viewBox="0 0 1440 100">
          <path d="M0,100 L1440,0 L1440,100 Z" fill="#f7f9f4" />
        </svg>

        {/* Nav bar */}
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          display: "flex", alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 48px",
          background: "rgba(10, 24, 13, 0.95)",
          backdropFilter: "blur(12px)",
          borderBottom: "1.5px solid rgba(168, 200, 150, 0.18)",
        }} className="navbar-container">
          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", gap: 16, cursor: "pointer", minWidth: 0 }} className="navbar-brand" onClick={() => navigate("/")}>
            <img src={loginicon} alt="Mental Swasthya logo" decoding="async" style={{
              width: 56, height: 56, borderRadius: 14,
              objectFit: "cover",
              border: "1.5px solid rgba(168,200,150,0.3)",
              boxShadow: "0 6px 20px rgba(0,0,0,0.45)",
            }} className="navbar-logo" />
            <div style={{ display: "flex", flexDirection: "column" }} className="brand-logo-text">
              <span style={{ 
                fontSize: 18, 
                fontWeight: 800, 
                letterSpacing: "0.16em", 
                textTransform: "uppercase", 
                color: "#e8f0e3",
                fontFamily: "'DM Sans', sans-serif"
              }}>
                Mental Swasthya
              </span>
              <span style={{
                fontSize: 9.5,
                fontWeight: 600,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "rgba(168,200,150,0.6)"
              }}>
                Empowering Wellness
              </span>
            </div>
          </div>

          {/* Links */}
          <nav aria-label="Primary" style={{ display: "flex", gap: 28 }} className="navbar-links">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: 12, fontWeight: 600, letterSpacing: "0.14em", textTransform: "uppercase",
                  color: item.id === activeTab ? "#a8c896" : "rgba(168,200,150,0.5)",
                  borderBottom: item.id === activeTab ? "1.5px solid #a8c896" : "none",
                  paddingBottom: 4,
                  transition: "all 0.25s",
                }}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA & Mobile Menu Toggle */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={handleStart}
              style={{
                display: "inline-flex", alignItems: "center", gap: 10,
                padding: "12px 24px", borderRadius: 99,
                background: "#a8c896", color: "#0d1b0b",
                border: "none", cursor: "pointer",
                fontSize: 12, fontWeight: 700, letterSpacing: "0.08em",
                fontFamily: "'DM Sans', sans-serif",
                boxShadow: "0 8px 24px rgba(168,200,150,0.25)",
                transition: "all 0.25s cubic-bezier(0.16,1,0.3,1)",
              }}
              className="header-cta-btn"
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#c2dcb2";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#a8c896";
                e.currentTarget.style.transform = "none";
              }}
            >
              Get Started
              <FiArrowRight size={14} />
            </button>

            {/* Mobile Hamburger toggle */}
            <button
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={mobileMenuOpen}
              aria-controls="landing-mobile-menu"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "center",
                padding: 8,
                minWidth: 44,
                minHeight: 44,
                color: "#e8f0e3"
              }}
              className="mobile-menu-btn"
            >
              {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>

          {/* Mobile Overlay Menu */}
          {mobileMenuOpen && (
            <div
              className="mobile-menu-backdrop"
              aria-hidden="true"
              onClick={() => setMobileMenuOpen(false)}
            />
          )}
          {mobileMenuOpen && (
            <nav id="landing-mobile-menu" aria-label="Mobile" className="mobile-menu-panel" style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              background: "rgba(10, 24, 13, 0.98)",
              backdropFilter: "blur(20px)",
              borderBottom: "1.5px solid rgba(168, 200, 150, 0.18)",
              padding: "24px 32px",
              display: "flex",
              flexDirection: "column",
              gap: 6,
              zIndex: 100
            }}>
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    scrollToSection(item.id);
                    setMobileMenuOpen(false);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: item.id === activeTab ? "#a8c896" : "rgba(168,200,150,0.6)",
                    textAlign: "left",
                    padding: "12px 0",
                    minHeight: 44
                  }}
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => {
                  handleStart();
                  setMobileMenuOpen(false);
                }}
                style={{
                  width: "100%",
                  padding: "14px",
                  borderRadius: 14,
                  background: "#a8c896",
                  color: "#0d1b0b",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 700,
                  fontFamily: "'DM Sans', sans-serif",
                  marginTop: 12
                }}
              >
                Get Started
              </button>
            </nav>
          )}
        </div>

        {/* Hero content */}
        <div style={{
          position: "relative", zIndex: 10,
          maxWidth: 1200, margin: "0 auto", width: "100%",
          padding: "160px 48px 140px",
          display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 48, alignItems: "center",
        }} className="hero-content">
          
          {/* Hero Left */}
          <div>
            <div style={{ marginBottom: 20 }}>
              <span style={{
                fontSize: 10, fontWeight: 600, letterSpacing: "0.22em",
                textTransform: "uppercase", color: "rgba(168,200,150,0.5)",
                display: "inline-flex", alignItems: "center", gap: 10,
              }}>
                <span style={{ display: "inline-block", width: 20, height: 1, background: "rgba(168,200,150,0.3)" }} />
                Mindfulness & Balance
              </span>
            </div>

            <h1 style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "clamp(2.3rem, 6vw, 4.8rem)",
              fontWeight: 600,
              color: "#e8f0e3",
              lineHeight: 1.05,
              letterSpacing: "-0.02em",
              marginBottom: 24,
            }}>
              Cultivate Calm:<br />
              Personalized Tools for<br />
              <em style={{ fontStyle: "italic", color: "#a8c896" }}>Inner Wellness</em>
            </h1>

            <p style={{
              fontSize: 15,
              color: "rgba(232,240,227,0.58)",
              lineHeight: 1.7,
              maxWidth: 480,
              fontWeight: 300,
              marginBottom: 36,
            }}>
              Unlock Your Personalized Daily Wellness Kit. Select your daily practice from the tools below to support your growth.
            </p>

            <button
              onClick={handleStart}
              style={{
                display: "inline-flex", alignItems: "center", gap: 12,
                padding: "16px 32px",
                borderRadius: 16,
                background: "#1a2416",
                color: "#e8f0e3",
                border: "1px solid rgba(168,200,150,0.2)",
                cursor: "pointer",
                fontSize: 13, fontWeight: 600,
                letterSpacing: "0.04em",
                fontFamily: "'DM Sans', sans-serif",
                boxShadow: "0 8px 28px rgba(0,0,0,0.3)",
                transition: "all 0.25s cubic-bezier(0.16,1,0.3,1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#7d9667";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#1a2416";
                e.currentTarget.style.transform = "none";
              }}
            >
              Start Wellness Journey
              <FiArrowRight size={14} />
            </button>
          </div>

          {/* Hero Right: Illustration Slideshow */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{
              position: "relative",
              width: "100%", maxWidth: 440,
              aspectRatio: "1/1",
              borderRadius: 36,
              overflow: "hidden",
              border: "1.5px solid rgba(168,200,150,0.22)",
              boxShadow: "0 24px 60px rgba(0,0,0,0.4)",
              touchAction: "pan-y",
            }} className="hero-slideshow" {...slideSwipe}>
              {slides.map((slide, idx) => (
                <img 
                  key={idx}
                  src={slide} 
                  alt={`Meditation illustration ${idx + 1}`} 
                  loading={idx === 0 ? "eager" : "lazy"}
                  decoding="async"
                  aria-hidden={currentSlide !== idx}
                  className="hero-slide-img"
                  style={{ 
                    position: "absolute",
                    inset: 0,
                    width: "100%", 
                    height: "100%", 
                    objectFit: "cover",
                    opacity: currentSlide === idx ? 1 : 0,
                    transform: currentSlide === idx ? "scale(1)" : "scale(1.05)",
                    transition: "opacity 1.2s ease-in-out, transform 1.2s ease-in-out",
                  }}
                />
              ))}
              <div style={{
                position: "absolute", inset: 0,
                background: "linear-gradient(to top, rgba(13,27,11,0.25) 0%, transparent 60%)",
                pointerEvents: "none"
              }} />

              {/* Navigation Indicators */}
              <div style={{
                position: "absolute",
                bottom: 20,
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                gap: 0,
                zIndex: 20,
              }} className="hero-dots">
                {slides.map((_, idx) => (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => setCurrentSlide(idx)}
                    aria-label={`Show slide ${idx + 1}`}
                    aria-current={currentSlide === idx ? "true" : undefined}
                    className="hero-dot"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span style={{
                      display: "block",
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: currentSlide === idx ? "#a8c896" : "rgba(255, 255, 255, 0.4)",
                      transition: "background 0.3s",
                    }} />
                  </button>
                ))}
              </div>
            </div>
          </div>

        </div>

      </header>

      {/* ══════════════════════════ MARQUEE ══════════════════════════ */}
      <Marquee />

      {/* ══════════════════════════ BODY CONTENT ══════════════════════════ */}
      <main style={{ padding: "60px 48px 0", maxWidth: 1200, margin: "0 auto" }} className="main-container">
        
        {/* ─── 1. Importance of Mental Wellness in Today's World ─── */}
        <Reveal>
          <section id="why-wellness" style={{
            background: "#ffffff",
            border: "1px solid #dde8d5",
            borderRadius: 32,
            padding: "48px 40px",
            marginBottom: 60,
            boxShadow: "0 4px 20px rgba(22,35,20,0.02)"
          }} className="section-card">
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48 }} className="stack-grid">
              <div>
                <p style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7d9667", marginBottom: 12 }}>
                  The Modern Challenge
                </p>
                <h2 style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)",
                  fontWeight: 600, color: "#1a2416",
                  lineHeight: 1.1, letterSpacing: "-0.02em",
                }}>
                  The high cost of a<br />
                  <em style={{ fontStyle: "italic", color: "#7d9667" }}>hyper-connected world</em>
                </h2>
                <p style={{ fontSize: 14.5, color: "#6b7f63", lineHeight: 1.7, marginTop: 18, fontWeight: 300 }}>
                  We live in an era of constant stimulation. Between work demands, continuous digital notifications, and urban acceleration, our nervous systems remain in a state of high alert. Chronic stress, anxiety, and sleep depletion are the modern defaults.
                </p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 20, justifyContent: "center" }}>
                {[
                  { title: "Digital Fatigue", text: "Endless notifications and screen time keeps cortisol levels elevated, disrupting natural cognitive rest cycles.", signage: <FiSmartphone /> },
                  { title: "Sympathetic Dominance", text: "Stress forces our bodies into a chronic fight-or-flight response, taxing cardiovascular and immune systems.", signage: <FiShield /> },
                  { title: "Emotional Depletion", text: "Without conscious pauses, we operate on auto-pilot, disconnecting from our inner aspirations and virtues.", signage: <FiAward /> }
                ].map((item, idx) => (
                  <div key={idx} style={{ display: "flex", gap: 16 }}>
                    <div style={{
                      width: 38, height: 38, borderRadius: 10,
                      background: "rgba(125,150,103,0.08)", border: "1px solid rgba(125,150,103,0.18)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "#7d9667", flexShrink: 0
                    }}>
                      {item.signage}
                    </div>
                    <div>
                      <h4 style={{ fontSize: 13.5, fontWeight: 600, color: "#1a2416", marginBottom: 2 }}>{item.title}</h4>
                      <p style={{ fontSize: 12.5, color: "#7a8f72", lineHeight: 1.5 }}>{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </Reveal>

        {/* ─── 2. Science Backed Tools Section (with Signages) ─── */}
        <section id="tools">
          <Reveal>
            <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 40 }}>
              <p style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7d9667" }}>
                Science-Backed Toolkit
              </p>
              <h2 style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: "clamp(1.85rem, 4vw, 3.4rem)",
                fontWeight: 600, color: "#1a2416",
                lineHeight: 1.1, letterSpacing: "-0.02em",
              }}>
                Mental wellness tools supported by<br />
                <em style={{ fontStyle: "italic", color: "#7d9667" }}>empirical clinical science</em>
              </h2>
            </div>
          </Reveal>

          {/* Science Tools Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 20, marginBottom: 60 }}>
            {tools.map((tool, i) => (
              <Reveal key={tool.title} delay={i * 0.08}>
                <div
                  onMouseEnter={() => setHoveredCard(i)}
                  onMouseLeave={() => setHoveredCard(null)}
                  style={{
                    borderRadius: 24,
                    background: "#ffffff",
                    border: `1.5px solid ${hoveredCard === i ? tool.border : "#e8eee3"}`,
                    padding: "28px 24px",
                    position: "relative", overflow: "hidden",
                    cursor: "default",
                    transform: hoveredCard === i ? "translateY(-4px)" : "none",
                    boxShadow: hoveredCard === i
                      ? "0 20px 40px rgba(22,35,20,0.1), 0 4px 12px rgba(22,35,20,0.04)"
                      : "0 2px 10px rgba(22,35,20,0.04)",
                    transition: "all 0.3s cubic-bezier(0.16,1,0.3,1)",
                    display: "flex", flexDirection: "column",
                    minHeight: 280,
                  }}
                  className="tool-card"
                >
                  <div>
                    {/* Background number */}
                    <div style={{
                      position: "absolute", top: -14, right: 12,
                      fontFamily: "'Cormorant Garamond', serif",
                      fontSize: "6.5rem", fontWeight: 600, lineHeight: 1,
                      color: hoveredCard === i ? tool.accent.replace("0.07", "0.12").replace("0.08", "0.14") : "rgba(22,35,20,0.03)",
                      transition: "color 0.3s",
                      pointerEvents: "none", userSelect: "none",
                    }}>
                      {tool.num}
                    </div>

                    {/* Icon signage */}
                    <div style={{
                      width: 44, height: 44, borderRadius: 12,
                      background: tool.accent,
                      border: `1px solid ${tool.border}`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: tool.color, marginBottom: 20,
                      transition: "transform 0.3s",
                      transform: hoveredCard === i ? "scale(1.08)" : "none",
                    }}>
                      {tool.icon}
                    </div>

                    {/* Title */}
                    <h3 style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontSize: "1.55rem", fontWeight: 600,
                      color: "#1a2416", letterSpacing: "-0.01em",
                      lineHeight: 1.1, marginBottom: 12,
                    }}>
                      {tool.title}
                    </h3>

                    {/* Text */}
                    <p style={{
                      fontSize: 13, color: "#6b7f63",
                      lineHeight: 1.65, fontWeight: 400,
                    }}>
                      {tool.text}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ─── 3. Platform Features Description (with Signages) ─── */}
        <section id="features">
          <Reveal>
            <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 40 }}>
              <p style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7d9667" }}>
                Core Features
              </p>
              <h2 style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: "clamp(1.85rem, 4vw, 3.4rem)",
                fontWeight: 600, color: "#1a2416",
                lineHeight: 1.1, letterSpacing: "-0.02em",
              }}>
                Intuitively designed interfaces to<br />
                <em style={{ fontStyle: "italic", color: "#7d9667" }}>optimize your daily rituals</em>
              </h2>
            </div>
          </Reveal>

          {/* Features list */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 24, marginBottom: 60 }}>
            {features.map((feat, i) => (
              <Reveal key={feat.title} delay={i * 0.06}>
                <div 
                  onMouseEnter={() => setHoveredFeature(i)}
                  onMouseLeave={() => setHoveredFeature(null)}
                  style={{
                    background: "#ffffff",
                    border: "1px solid #dde8d5",
                    borderRadius: 20,
                    padding: 24,
                    boxShadow: hoveredFeature === i ? "0 12px 24px rgba(22,35,20,0.06)" : "none",
                    transform: hoveredFeature === i ? "translateY(-2px)" : "none",
                    transition: "all 0.25s",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div style={{
                    width: 40, height: 40, borderRadius: 10,
                    background: "rgba(125,150,103,0.06)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    color: "#7d9667", marginBottom: 18,
                  }}>
                    {feat.icon}
                  </div>
                  <span style={{ fontSize: 9.5, fontWeight: 700, color: "#7d9667", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>
                    {feat.badge}
                  </span>
                  <h4 style={{ fontSize: 15, fontWeight: 600, color: "#1a2416", marginBottom: 10 }}>{feat.title}</h4>
                  <p style={{ fontSize: 12.5, color: "#6b7f63", lineHeight: 1.6, fontWeight: 300 }}>{feat.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ─── 4. Referral Code & 3 Months Free Promo (Custom layout matching uploaded design) ─── */}
        <Reveal>
          <section id="offer" style={{
            background: "#ffffff",
            border: "1.5px solid #d36a3d",
            borderRadius: 32,
            padding: 0,
            overflow: "hidden",
            marginBottom: 60,
            boxShadow: "0 15px 45px rgba(211,106,61,0.08)",
            maxWidth: 820,
            margin: "0 auto 60px"
          }} className="promo-section">
            
            {/* Promo Banner Top (Special Offer) */}
            <div style={{
              background: "linear-gradient(135deg, #fdf6f0 0%, #fffdfc 100%)",
              padding: "40px 48px",
              display: "grid",
              gridTemplateColumns: "100px 1fr",
              gap: 28,
              alignItems: "center",
              borderBottom: "1.5px dashed #f0ccb9"
            }} className="stack-grid promo-banner-part promo-top">
              
              {/* Gift SVG Drawing */}
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{
                  width: 90, height: 90, borderRadius: 24,
                  background: "linear-gradient(135deg, #d36a3d 0%, #e2875b 100%)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#ffffff",
                  boxShadow: "0 10px 24px rgba(211,106,61,0.3)"
                }}>
                  <FiGift size={44} />
                </div>
              </div>

              {/* Offer Text */}
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.18em", color: "#d36a3d", textTransform: "uppercase" }}>
                  Special Offer
                </span>
                <h3 style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "clamp(1.8rem, 3.5vw, 2.4rem)",
                  fontWeight: 600,
                  color: "#3a2118",
                  lineHeight: 1.1,
                  margin: "4px 0 8px"
                }}>
                  Get 1 Months FREE
                </h3>
                <p style={{ fontSize: 13.5, color: "#6e5d57", lineHeight: 1.5 }}>
                  Sign up now and get your first 1 month's subscription absolutely <strong style={{ color: "#d36a3d" }}>free</strong> as an introductory offer!
                </p>
                
                <button
                  onClick={handleStart}
                  style={{
                    background: "#d36a3d",
                    color: "#ffffff",
                    border: "none",
                    padding: "14px 28px",
                    borderRadius: 14,
                    fontSize: 12.5,
                    fontWeight: 700,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    boxShadow: "0 6px 18px rgba(211,106,61,0.25)",
                    width: "fit-content",
                    marginTop: 14,
                    transition: "all 0.25s"
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "#e2875b"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#d36a3d"; }}
                >
                  Sign Up Now
                </button>
              </div>

            </div>

            {/* Promo Banner Bottom (Share Referral) */}
            <div style={{
              background: "#fff9f6",
              padding: "40px 48px",
              display: "grid",
              gridTemplateColumns: "1.2fr 1fr",
              gap: 40,
              alignItems: "center"
            }} className="stack-grid promo-banner-part">
              
              <div>
                <h4 style={{ fontSize: 14, fontWeight: 700, color: "#3a2118", marginBottom: 8, letterSpacing: "0.02em" }}>
                  Share the love, get more free!
                </h4>
                <p style={{ fontSize: 12.5, color: "#6e5d57", lineHeight: 1.6 }}>
                  If your loved ones register using your gift code, you will get an additional <strong style={{ color: "#d36a3d" }}>1 more month</strong> subscription absolutely free.
                </p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <span style={{ fontSize: 10, fontWeight: 700, color: "#6e5d57", uppercase: "true", letterSpacing: "0.06em", display: "block", marginBottom: 6 }}>
                    Your Gift Code:
                  </span>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#ffffff",
                    border: "1.5px solid #ebd9cf",
                    borderRadius: 12,
                    padding: "4px 4px 4px 14px",
                    justifyContent: "space-between"
                  }}>
                    <span style={{ fontMono: "true", fontSize: 13, fontWeight: 700, color: "#3a2118", letterSpacing: "0.04em" }}>
                      SHARE_JOY24
                    </span>
                    <button
                      onClick={copyReferralCode}
                      style={{
                        background: "#fdf3ee",
                        border: "1px solid #ebd9cf",
                        borderRadius: 8,
                        padding: "6px 12px",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#d36a3d",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        transition: "all 0.2s"
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "#ebd9cf"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = "#fdf3ee"; }}
                    >
                      <FiCopy size={12} />
                      Copy Code
                    </button>
                  </div>
                </div>

                <button
                  onClick={copyReferralCode}
                  style={{
                    border: "1.5px solid #d36a3d",
                    background: "transparent",
                    color: "#d36a3d",
                    padding: "12px 0",
                    borderRadius: 12,
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    transition: "all 0.25s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(211,106,61,0.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  <FiShare2 size={13} />
                  Invite Friends
                </button>
              </div>

            </div>

          </section>
        </Reveal>

        {/* ─── YOUR DAILY PLAN BANNER ─── */}
        <Reveal>
          <div style={{
            background: "#e2eadc",
            border: "1px solid #c8d8be",
            borderRadius: 28,
            padding: "36px 40px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
            marginBottom: 60,
          }} className="daily-plan">
            <div>
              <h3 style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: "1.8rem", fontWeight: 600,
                color: "#1a2416", letterSpacing: "-0.01em",
              }}>
                Your Daily Plan
              </h3>
              <p style={{ fontSize: 13, color: "#6b7f63", marginTop: 2 }}>
                A preview of how we guide your mental wellness every day.
              </p>
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 24,
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: "#ffffff", border: "1px solid #dde7d6",
                  display: "flex", alignItems: "center",
                  color: "#b5893d", flexShrink: 0, justifyContent: "center"
                }}>
                  <FiBookOpen size={18} />
                </div>
                <div>
                  <p style={{ fontSize: 13, fontWeight: 600, color: "#1a2416", marginBottom: 2 }}>My Daily Intention</p>
                  <span style={{ fontSize: 11, color: "#768c6e" }}>(e.g., 'To be present.')</span>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: "#ffffff", border: "1px solid #dde7d6",
                  display: "flex", alignItems: "center",
                  color: "#4a7c59", flexShrink: 0, justifyContent: "center"
                }}>
                  <FiWind size={18} />
                </div>
                <div>
                  <p style={{ fontSize: 13, fontWeight: 600, color: "#1a2416", marginBottom: 2 }}>Regulated Breathing</p>
                  <span style={{ fontSize: 11, color: "#768c6e" }}>Animation preview</span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* ─── SECTION 1: CURATED ARTICLES ─── */}
        <section id="articles" style={{ marginBottom: 60 }}>
          <Reveal>
            <div style={{
              background: "#ffffff",
              border: "1.5px solid #e8eee3",
              padding: "36px 32px",
              borderRadius: 32,
              boxShadow: "0 4px 20px rgba(22,35,20,0.05)"
            }} className="articles-card">
              {/* Header with Navigation Controls */}
              <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: 16, marginBottom: 28 }}>
                <div>
                  <span style={{ fontSize: 10, fontWeight: 700, color: "#7d9667", textTransform: "uppercase", letterSpacing: "0.16em" }}>
                    WELLNESS INSIGHTS
                  </span>
                  <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(1.7rem, 5vw, 2rem)", fontWeight: 700, color: "#1a2416", marginTop: 2 }}>
                    Curated Articles
                  </h3>
                  <p style={{ fontSize: 13, color: "#6b7f63", marginTop: 4 }}>
                    Explore expert insights, mindful strategies, and science-backed reads to support your mental wellbeing.
                  </p>
                </div>

                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <button
                    type="button"
                    onClick={() => setArticleIndex((prev) => (prev === 0 ? curatedArticles.length - 1 : prev - 1))}
                    style={{ width: 44, height: 44, borderRadius: "50%", background: "#f5faf2", border: "1px solid #dbe6d6", color: "#29401f", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}
                    title="Previous Article"
                    aria-label="Previous article"
                  >
                    <FiChevronLeft size={18} />
                  </button>
                  <button
                    type="button"
                    onClick={() => setArticleIndex((prev) => (prev + 1) % curatedArticles.length)}
                    style={{ width: 44, height: 44, borderRadius: "50%", background: "#f5faf2", border: "1px solid #dbe6d6", color: "#29401f", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}
                    title="Next Article"
                    aria-label="Next article"
                  >
                    <FiChevronRight size={18} />
                  </button>
                </div>
              </div>

              {/* Active Curated Article Showcase */}
              <div style={{
                background: curatedArticles[articleIndex].bgGradient,
                borderRadius: 24,
                padding: "32px 28px",
                color: "#ffffff",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                position: "relative",
                overflow: "hidden",
                touchAction: "pan-y"
              }} className="article-showcase" {...articleSwipe}>
                {/* Background SVG Grid pattern */}
                <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.05, pointerEvents: "none" }}>
                  <rect width="100%" height="100%" fill="url(#agrid)" />
                </svg>

                <div style={{ position: "relative", zIndex: 10 }}>
                  <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, marginBottom: 16 }}>
                    <span style={{
                      fontSize: 10,
                      fontWeight: 800,
                      textTransform: "uppercase",
                      letterSpacing: "0.14em",
                      background: "rgba(255,255,255,0.18)",
                      border: "1px solid rgba(255,255,255,0.3)",
                      color: "#ffffff",
                      padding: "4px 12px",
                      borderRadius: 99
                    }}>
                      {curatedArticles[articleIndex].category}
                    </span>

                    <span style={{ fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.8)", display: "inline-flex", alignItems: "center", gap: 4 }}>
                      <FiClock size={13} /> {curatedArticles[articleIndex].readTime}
                    </span>
                  </div>

                  <h4 style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: "clamp(1.45rem, 4.5vw, 1.85rem)",
                    fontWeight: 700,
                    lineHeight: 1.25,
                    color: "#ffffff",
                    marginBottom: 12,
                    cursor: "pointer"
                  }} onClick={handleStart}>
                    {curatedArticles[articleIndex].title}
                  </h4>

                  <p style={{
                    fontSize: "0.95rem",
                    color: "rgba(255,255,255,0.9)",
                    lineHeight: 1.6,
                    maxWidth: "850px",
                    marginBottom: 24
                  }}>
                    {curatedArticles[articleIndex].message}
                  </p>

                  <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 16, borderTop: "1px solid rgba(255,255,255,0.2)", paddingTop: 20 }}>
                    <span style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", fontWeight: 600 }}>
                      Published: {curatedArticles[articleIndex].date}
                    </span>

                    <button
                      type="button"
                      onClick={() => {
                        const articleUrl = curatedArticles[articleIndex].url;
                        if (articleUrl) window.open(articleUrl, "_blank", "noopener,noreferrer");
                        else handleStart();
                      }}
                      style={{
                        padding: "10px 22px",
                        borderRadius: 14,
                        background: "#ffffff",
                        color: "#1e3019",
                        border: "none",
                        fontSize: 12,
                        fontWeight: 800,
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                        transition: "all 0.2s"
                      }}
                    >
                      Read Full Article <FiArrowRight size={14} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Article Indicators */}
              <div style={{ display: "flex", gap: 0, justifyContent: "center", marginTop: 8 }}>
                {curatedArticles.map((_, idx) => (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => setArticleIndex(idx)}
                    aria-label={`Show article ${idx + 1}`}
                    aria-current={articleIndex === idx ? "true" : undefined}
                    style={{ background: "none", border: "none", padding: 0, minWidth: 28, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                  >
                    <span style={{
                      display: "block",
                      width: articleIndex === idx ? 24 : 8,
                      height: 8,
                      borderRadius: 4,
                      background: articleIndex === idx ? "#7d9667" : "#e2ebd9",
                      transition: "all 0.3s"
                    }} />
                  </button>
                ))}
              </div>

            </div>
          </Reveal>
        </section>

        {/* ─── SECTION 2: OUR COMMUNITY (FULL-WIDTH DEDICATED BLOCK DOWN BELOW) ─── */}
        <section id="community" style={{ marginBottom: 80 }}>
          <Reveal delay={0.08}>
            <div style={{
              background: "linear-gradient(135deg, #162314 0%, #0d1b0b 100%)",
              padding: "48px 36px",
              borderRadius: 36,
              boxShadow: "0 18px 45px rgba(22,35,20,0.2)",
              color: "#e8f0e3",
              position: "relative",
              overflow: "hidden"
            }} className="community-card">
              {/* Subtle Ambient Glow & Dot Grid */}
              <div style={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, borderRadius: "50%", background: "rgba(168,200,150,0.08)", filter: "blur(60px)", pointerEvents: "none" }} />
              <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.04, pointerEvents: "none" }}>
                <rect width="100%" height="100%" fill="url(#agrid)" />
              </svg>

              <div style={{ position: "relative", zIndex: 10 }}>
                {/* Header */}
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: 20, marginBottom: 32, borderBottom: "1px solid rgba(255,255,255,0.12)", paddingBottom: 20 }}>
                  <div>
                    <span style={{ fontSize: 10, fontWeight: 800, color: "#a8c896", textTransform: "uppercase", letterSpacing: "0.18em", background: "rgba(168,200,150,0.12)", border: "1px solid rgba(168,200,150,0.25)", padding: "4px 12px", borderRadius: 99 }}>
                      MEMBER STORIES & REVIEWS
                    </span>
                    <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(1.9rem, 6vw, 2.4rem)", fontWeight: 700, color: "#e8f0e3", marginTop: 12 }}>
                      Our Community
                    </h3>
                    <p style={{ fontSize: 13, color: "rgba(232,240,227,0.75)", marginTop: 4 }}>
                      Real experiences from practitioners finding peace, focus, and clarity with MentalSwasthya.
                    </p>
                  </div>

                  {/* Navigation Arrows for Community Review Carousel */}
                  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <button
                      type="button"
                      onClick={() => setReviewIndex((prev) => (prev === 0 ? communityReviews.length - 1 : prev - 1))}
                      style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", color: "#ffffff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}
                      title="Previous Review"
                      aria-label="Previous review"
                    >
                      <FiChevronLeft size={20} />
                    </button>
                    <button
                      type="button"
                      onClick={() => setReviewIndex((prev) => (prev + 1) % communityReviews.length)}
                      style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", color: "#ffffff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}
                      title="Next Review"
                      aria-label="Next review"
                    >
                      <FiChevronRight size={20} />
                    </button>
                  </div>
                </div>

                {/* Community Review Card */}
                <div style={{
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  borderRadius: 28,
                  padding: "36px 32px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 22,
                  touchAction: "pan-y"
                }} className="review-card" {...reviewSwipe}>
                  <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
                    {/* Reviewer Name & Role */}
                    <div>
                      <h4 style={{ fontSize: 20, fontWeight: 800, color: "#ffffff", marginBottom: 4, letterSpacing: "-0.01em" }}>
                        {communityReviews[reviewIndex].name}
                      </h4>
                      <p style={{ fontSize: 13, color: "#a8c896", fontWeight: 600 }}>
                        {communityReviews[reviewIndex].role}
                      </p>
                    </div>

                    {/* Rating and Date */}
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10 }}>
                      <div style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        background: "rgba(251, 191, 36, 0.12)",
                        border: "1px solid rgba(251, 191, 36, 0.3)",
                        padding: "6px 14px",
                        borderRadius: 99
                      }}>
                        <span style={{ color: "#fbbf24", fontSize: 15, letterSpacing: "2px" }}>
                          {"★".repeat(communityReviews[reviewIndex].rating)}
                        </span>
                        <span style={{ fontSize: 12, fontWeight: 800, color: "#fbbf24" }}>
                          {communityReviews[reviewIndex].rating}.0 Rating
                        </span>
                      </div>

                      <span style={{ fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.5)", background: "rgba(255,255,255,0.08)", padding: "6px 14px", borderRadius: 99 }}>
                        {communityReviews[reviewIndex].date}
                      </span>
                    </div>
                  </div>

                  {/* Review Quote Block */}
                  <p className="review-quote" style={{
                    fontSize: "1.15rem",
                    color: "rgba(232,240,227,0.94)",
                    lineHeight: 1.7,
                    fontWeight: 400,
                    fontStyle: "italic",
                    borderLeft: "3px solid #a8c896",
                    paddingLeft: 20,
                    margin: 0
                  }}>
                    "{communityReviews[reviewIndex].review}"
                  </p>
                </div>

                {/* Bottom Bar: Indicators & Share Feedback Action Button */}
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 20, marginTop: 28 }}>
                  <div style={{ display: "flex", gap: 0, alignItems: "center", marginLeft: -6 }}>
                    {communityReviews.map((_, idx) => (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => setReviewIndex(idx)}
                        aria-label={`Show review ${idx + 1}`}
                        aria-current={reviewIndex === idx ? "true" : undefined}
                        style={{ background: "none", border: "none", padding: "0 3px", minWidth: 28, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                      >
                        <span style={{
                          display: "block",
                          width: reviewIndex === idx ? 28 : 10,
                          height: 10,
                          borderRadius: 5,
                          background: reviewIndex === idx ? "#a8c896" : "rgba(255,255,255,0.25)",
                          transition: "all 0.3s"
                        }} />
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => {
                      const btn = document.querySelector('button[title="Share your experience"]');
                      if (btn) btn.click();
                      else handleStart();
                    }}
                    style={{
                      padding: "14px 28px",
                      borderRadius: 16,
                      background: "#a8c896", color: "#0d1b0b",
                      border: "none", cursor: "pointer",
                      fontSize: 13, fontWeight: 800,
                      fontFamily: "'DM Sans', sans-serif",
                      boxShadow: "0 6px 20px rgba(168,200,150,0.25)",
                      transition: "all 0.25s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "#c2dcb2"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "#a8c896"; }}
                  >
                    💬 Share Your Feedback
                    <FiArrowRight size={14} />
                  </button>
                </div>
              </div>
            </div>
          </Reveal>
        </section>

          {/* ══════════════════════════ CONTACT US ══════════════════════════ */}
          <section id="contact" style={{
            padding: "clamp(60px, 8vw, 100px) clamp(20px, 8vw, 48px)",
            background: "linear-gradient(180deg, #ffffff 0%, #f4faf0 100%)",
            borderTop: "1px solid rgba(125,150,103,0.08)",
            position: "relative"
          }} className="contact-section">
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "clamp(32px, 8vw, 64px)", alignItems: "start" }} className="contact-grid">
                
                {/* Left Column: Details */}
                <Reveal direction="left">
                  <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
                    <div>
                      <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7d9667" }}>
                        Reach Out
                      </span>
                      <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(1.8rem, 5vw, 3rem)", fontWeight: 500, color: "#1c3217", marginTop: 12, lineHeight: 1.1 }}>
                        We'd love to hear <br />from you.
                      </h2>
                      <p style={{ fontSize: "clamp(13px, 2vw, 14.5px)", color: "#556b50", marginTop: 20, lineHeight: 1.7, fontWeight: 300 }}>
                        Whether you have a question about features, subscriptions, or simply want to share your mindfulness journey, our friendly team is here to support you.
                      </p>
                    </div>

                    {/* Contact details blocks */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                      
                      {/* Call support */}
                      <div style={{ display: "flex", gap: 16, alignItems: "center", background: "#ffffff", padding: "clamp(12px, 4vw, 18px) clamp(14px, 4vw, 24px)", borderRadius: 20, border: "1px solid rgba(125,150,103,0.12)", boxShadow: "0 8px 25px rgba(80,105,67,0.02)" }}>
                        <div style={{ width: 44, height: 44, borderRadius: 12, background: "#eef6ea", display: "flex", alignItems: "center", justifyContent: "center", color: "#7d9667", flexShrink: 0 }}>
                          <FiPhone size={18} style={{ margin: "auto" }} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h4 style={{ fontSize: "clamp(10px, 2vw, 10.5px)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#8a9a80" }}>Call Us</h4>
                          <p style={{ fontSize: "clamp(12px, 2.5vw, 14px)", fontWeight: 600, color: "#22331b", marginTop: 2 }}>+91 92235 50682</p>
                        </div>
                      </div>

                      {/* Email Support */}
                      <div style={{ display: "flex", gap: 16, alignItems: "center", background: "#ffffff", padding: "clamp(12px, 4vw, 18px) clamp(14px, 4vw, 24px)", borderRadius: 20, border: "1px solid rgba(125,150,103,0.12)", boxShadow: "0 8px 25px rgba(80,105,67,0.02)" }}>
                        <div style={{ width: 44, height: 44, borderRadius: 12, background: "#eef6ea", display: "flex", alignItems: "center", justifyContent: "center", color: "#7d9667", flexShrink: 0 }}>
                          <FiMail size={18} style={{ margin: "auto" }} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h4 style={{ fontSize: "clamp(10px, 2vw, 10.5px)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#8a9a80" }}>Email Support</h4>
                          <p style={{ fontSize: "clamp(12px, 2.5vw, 14px)", fontWeight: 600, color: "#22331b", marginTop: 2, overflowWrap: "anywhere" }}>support@mentalswasthya.com</p>
                        </div>
                      </div>

                      {/* Office Location */}
                      <div style={{ display: "flex", gap: 16, alignItems: "center", background: "#ffffff", padding: "clamp(12px, 4vw, 18px) clamp(14px, 4vw, 24px)", borderRadius: 20, border: "1px solid rgba(125,150,103,0.12)", boxShadow: "0 8px 25px rgba(80,105,67,0.02)" }}>
                        <div style={{ width: 44, height: 44, borderRadius: 12, background: "#eef6ea", display: "flex", alignItems: "center", justifyContent: "center", color: "#7d9667", flexShrink: 0 }}>
                          <FiMapPin size={18} style={{ margin: "auto" }} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h4 style={{ fontSize: "clamp(10px, 2vw, 10.5px)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#8a9a80" }}>Office Location</h4>
                          <p style={{ fontSize: "clamp(12px, 2.5vw, 14px)", fontWeight: 600, color: "#22331b", marginTop: 2 }}>Mumbai, Maharashtra, India</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </Reveal>

                {/* Right Column: Contact form */}
                <Reveal direction="right" delay={0.1}>
                  <div style={{ background: "#ffffff", padding: "clamp(20px, 6vw, 36px)", borderRadius: 28, border: "1px solid rgba(125,150,103,0.12)", boxShadow: "0 20px 50px rgba(80,105,67,0.04)" }} className="form-card">
                    <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(1.3rem, 4vw, 1.8rem)", fontWeight: 600, color: "#1c3217", marginBottom: 8 }}>
                      Send us a Message
                    </h3>
                    <p style={{ fontSize: "clamp(11px, 2vw, 12.5px)", color: "#8a9a80", marginBottom: 28 }}>
                      Fill out the form below and we will get back to you within 24 hours.
                    </p>

                    <form onSubmit={handleContactSubmit} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                      
                      {/* Name Field */}
                      <div>
                        <label style={{ display: "block", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", color: "#8a9a80", marginBottom: 8 }} htmlFor="contact-name">
                          Your Name
                        </label>
                        <input
                          id="contact-name"
                          name="name"
                          autoComplete="name"
                          className="lp-input"
                          type="text"
                          value={contactName}
                          onChange={(e) => setContactName(e.target.value)}
                          placeholder="e.g. John Doe"
                          required
                          style={{
                            width: "100%", padding: "clamp(12px, 3vw, 14px) clamp(14px, 3vw, 18px)", borderRadius: 12,
                            border: "1px solid rgba(125,150,103,0.2)", outline: "none",
                            background: "#fbfdfa", transition: "all 0.25s",
                            fontFamily: "'DM Sans', sans-serif"
                          }}
                          onFocus={(e) => { e.currentTarget.style.borderColor = "#7d9667"; e.currentTarget.style.background = "#ffffff"; }}
                          onBlur={(e) => { e.currentTarget.style.borderColor = "rgba(125,150,103,0.2)"; e.currentTarget.style.background = "#fbfdfa"; }}
                        />
                      </div>

                      {/* Email Field */}
                      <div>
                        <label style={{ display: "block", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", color: "#8a9a80", marginBottom: 8 }} htmlFor="contact-email">
                          Email Address
                        </label>
                        <input
                          id="contact-email"
                          name="email"
                          autoComplete="email"
                          className="lp-input"
                          type="email"
                          value={contactEmail}
                          onChange={(e) => setContactEmail(e.target.value)}
                          placeholder="e.g. john@example.com"
                          required
                          style={{
                            width: "100%", padding: "clamp(12px, 3vw, 14px) clamp(14px, 3vw, 18px)", borderRadius: 12,
                            border: "1px solid rgba(125,150,103,0.2)", outline: "none",
                            background: "#fbfdfa", transition: "all 0.25s",
                            fontFamily: "'DM Sans', sans-serif"
                          }}
                          onFocus={(e) => { e.currentTarget.style.borderColor = "#7d9667"; e.currentTarget.style.background = "#ffffff"; }}
                          onBlur={(e) => { e.currentTarget.style.borderColor = "rgba(125,150,103,0.2)"; e.currentTarget.style.background = "#fbfdfa"; }}
                        />
                      </div>

                      {/* Message Field */}
                      <div>
                        <label style={{ display: "block", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", color: "#8a9a80", marginBottom: 8 }} htmlFor="contact-message">
                          Your Message
                        </label>
                        <textarea
                          id="contact-message"
                          name="message"
                          className="lp-input"
                          value={contactMessage}
                          onChange={(e) => setContactMessage(e.target.value)}
                          placeholder="Tell us what you need help with..."
                          required
                          rows={4}
                          style={{
                            width: "100%", padding: "clamp(12px, 3vw, 14px) clamp(14px, 3vw, 18px)", borderRadius: 12,
                            border: "1px solid rgba(125,150,103,0.2)", outline: "none",
                            background: "#fbfdfa", transition: "all 0.25s",
                            resize: "none", fontFamily: "'DM Sans', sans-serif"
                          }}
                          onFocus={(e) => { e.currentTarget.style.borderColor = "#7d9667"; e.currentTarget.style.background = "#ffffff"; }}
                          onBlur={(e) => { e.currentTarget.style.borderColor = "rgba(125,150,103,0.2)"; e.currentTarget.style.background = "#fbfdfa"; }}
                        />
                      </div>

                      {/* Submit button */}
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                          width: "100%", padding: "clamp(14px, 3vw, 16px) 0", borderRadius: 14,
                          background: "#7d9667", color: "#ffffff",
                          border: "none", cursor: "pointer", fontSize: "clamp(13px, 2.5vw, 13px)", minHeight: 48,
                          fontWeight: 600, fontFamily: "'DM Sans', sans-serif",
                          boxShadow: "0 6px 20px rgba(125,150,103,0.18)",
                          transition: "all 0.25s", marginTop: 8
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = "#6f865c"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = "#7d9667"; }}
                      >
                        {isSubmitting ? "Sending message..." : "Send Message"}
                      </button>

                    </form>
                  </div>
                </Reveal>

              </div>
            </div>
          </section>

      </main>

      {/* ══════════════════════════ FOOTER ══════════════════════════ */}
      <footer style={{ background: "#0a1208", padding: "60px 48px", borderTop: "1px solid rgba(168,200,150,0.12)" }} className="footer-container">
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 32, alignItems: "center" }} className="footer-layout">
          
          <div style={{ display: "flex", gap: 24 }} className="footer-links">
            <button onClick={() => navigate("/")} className="footer-link" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", fontSize: 12.5, fontWeight: 500, cursor: "pointer" }}>Home</button>
            <button onClick={handleStart} className="footer-link" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", fontSize: 12.5, fontWeight: 500, cursor: "pointer" }}>Programs</button>
            <button onClick={handleStart} className="footer-link" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", fontSize: 12.5, fontWeight: 500, cursor: "pointer" }}>Resources</button>
            <button onClick={handleStart} className="footer-link" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", fontSize: 12.5, fontWeight: 500, cursor: "pointer" }}>Community</button>
            <button onClick={handleStart} className="footer-link" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", fontSize: 12.5, fontWeight: 500, cursor: "pointer" }}>Blog</button>
            <button onClick={() => scrollToSection("contact")} className="footer-link" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", fontSize: 12.5, fontWeight: 500, cursor: "pointer" }}>Contact</button>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "flex-end" }} className="footer-right">
            <div style={{ display: "flex", gap: 14 }}>
              <button onClick={handleStart} className="footer-social" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", cursor: "pointer", padding: 0, display: "flex", alignItems: "center", justifyContent: "center" }} title="Facebook" aria-label="Facebook"><FiFacebook size={16} /></button>
              <button onClick={handleStart} className="footer-social" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", cursor: "pointer", padding: 0, display: "flex", alignItems: "center", justifyContent: "center" }} title="Twitter" aria-label="Twitter"><FiTwitter size={16} /></button>
              <button onClick={handleStart} className="footer-social" style={{ background: "none", border: "none", color: "rgba(168,200,150,0.45)", cursor: "pointer", padding: 0, display: "flex", alignItems: "center", justifyContent: "center" }} title="Instagram" aria-label="Instagram"><FiInstagram size={16} /></button>
            </div>
            <p style={{ fontSize: 11, color: "rgba(168,200,150,0.3)", letterSpacing: "0.04em" }}>
              MentalSwasthya &copy; 2025. All Rights Reserved.
            </p>
          </div>

        </div>
      </footer>

      {/* Global CSS rules for scroll animations & responsive grids */}
      <style>{`
        @keyframes marqueeScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-33.333%); }
        }
        @keyframes blobDrift1 {
          0%,100% { transform: translate(0,0) scale(1); }
          50% { transform: translate(-40px, 20px) scale(1.06); }
        }
        @keyframes blobDrift2 {
          0%,100% { transform: translate(0,0) scale(1); }
          50% { transform: translate(25px, -30px) scale(1.08); }
        }
        * { box-sizing: border-box; }

        /* Defaults */
        .lp-input { font-size: 13px; }
        .hero-dot { width: 16px; height: 24px; }
        .hero-slide-img { will-change: opacity; }
        .navbar-container {
          padding-top: calc(20px + env(safe-area-inset-top, 0px)) !important;
          padding-left: max(48px, env(safe-area-inset-left, 0px)) !important;
          padding-right: max(48px, env(safe-area-inset-right, 0px)) !important;
        }
        .mobile-menu-panel {
          max-height: calc(100vh - 72px);
          max-height: calc(100dvh - 72px - env(safe-area-inset-top, 0px));
          overflow-y: auto;
          overscroll-behavior: contain;
          padding-bottom: calc(24px + env(safe-area-inset-bottom, 0px)) !important;
        }
        .mobile-menu-backdrop {
          position: fixed;
          inset: 0;
          top: 100%;
          height: 100vh;
          background: rgba(5, 12, 4, 0.55);
          z-index: 99;
        }
        .footer-link { padding: 10px 6px; min-height: 40px; }
        .footer-social { width: 40px; height: 40px; }
        .mobile-menu-btn {
          display: none !important;
        }
        .navbar-links {
          display: flex;
          gap: 28px;
        }

        @media (max-width: 1024px) {
          .main-container {
            padding: 30px 16px 0 !important;
          }
          .navbar-container {
            padding: calc(12px + env(safe-area-inset-top, 0px)) max(18px, env(safe-area-inset-right, 0px)) 12px max(18px, env(safe-area-inset-left, 0px)) !important;
          }
          .navbar-logo {
            width: 42px !important;
            height: 42px !important;
            border-radius: 10px !important;
          }
          .brand-logo-text span:first-child {
            font-size: 14px !important;
            letter-spacing: 0.08em !important;
          }
          .brand-logo-text span:last-child {
            font-size: 8px !important;
          }
          .navbar-links {
            display: none !important;
          }
          .mobile-menu-btn {
            display: flex !important;
          }
          .header-cta-btn {
            display: none !important;
          }
          .section-card {
            padding: 28px 20px !important;
            border-radius: 24px !important;
            margin-bottom: 40px !important;
          }
          .promo-section {
            border-radius: 24px !important;
            margin-bottom: 40px !important;
          }
          .promo-banner-part {
            padding: 28px 20px !important;
          }
          .community-card {
            padding: 20px !important;
            border-radius: 20px !important;
          }
          .contact-section {
            padding: 56px 20px !important;
          }
          .footer-container {
            padding: 40px 20px calc(32px + env(safe-area-inset-bottom, 0px)) !important;
          }
          .hero-content {
            grid-template-columns: 1fr !important;
            text-align: center;
            padding: calc(112px + env(safe-area-inset-top, 0px)) 20px 88px !important;
            gap: 36px !important;
          }
          .hero-content > div:first-child {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .hero-content > div:first-child p {
            max-width: 560px !important;
          }
          .stack-grid {
            grid-template-columns: 1fr !important;
            gap: 28px !important;
          }
          .promo-top {
            text-align: center;
            justify-items: center;
            gap: 20px !important;
          }
          .promo-top > div:last-child {
            align-items: center;
          }
          .bottom-grid-stack {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
            margin-bottom: 40px !important;
          }
          .footer-layout {
            flex-direction: column !important;
            align-items: center !important;
            gap: 24px !important;
          }
          .footer-links {
            flex-wrap: wrap;
            justify-content: center;
          }
          .footer-right {
            align-items: center !important;
          }
          .article-stack {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
          .contact-grid {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
          }
          .form-card {
            padding: 20px !important;
          }
        }

        @media (max-width: 768px) {
          .lp-input { font-size: 16px !important; }
          .tool-card { min-height: 0 !important; }
          .daily-plan { padding: 28px 22px !important; border-radius: 24px !important; margin-bottom: 40px !important; }
          .articles-card { padding: 26px 18px !important; border-radius: 24px !important; }
          .article-showcase { padding: 26px 20px !important; border-radius: 20px !important; }
          .community-card { padding: 32px 20px !important; border-radius: 28px !important; }
          .review-card { padding: 24px 20px !important; border-radius: 22px !important; }
          .review-quote { font-size: 1.05rem !important; padding-left: 16px !important; }
          #articles { margin-bottom: 40px !important; }
          #community { margin-bottom: 40px !important; }
          .contact-section { padding: 44px 16px !important; }
          .footer-links { gap: 4px 12px !important; }
        }

        @media (max-width: 600px) {
          .hero-content {
            padding: calc(104px + env(safe-area-inset-top, 0px)) 18px 80px !important;
            gap: 32px !important;
          }
          .hero-dot { width: 13px; }
          .promo-banner-part { padding: 26px 18px !important; }
          .brand-logo-text span:first-child {
            font-size: 13px !important;
            letter-spacing: 0.06em !important;
          }
          .brand-logo-text span:last-child {
            font-size: 8px !important;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .lp-marquee { overflow-x: auto !important; scrollbar-width: none; }
          .lp-marquee::-webkit-scrollbar { display: none; }
          .lp-marquee-track, .lp-blob { animation: none !important; }
          .hero-slide-img { transition: none !important; transform: none !important; }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
